import React from "react";
import BankDetail from "../../organisms/InitialPagesComponents/BankKyc/BankDetail/BankDetail";

function BankDetailPage() {
  return <BankDetail />;
}

export default BankDetailPage;
